import { List } from "antd";
import styled, { css } from "styled-components";

export const StyledRequestControls = styled(List.Item)<{
  $isDesktop?: boolean;
}>`
  ${({ $isDesktop }) =>
    !$isDesktop &&
    css`
      & .ant-list-item-action {
        align-items: flex-start;
        display: flex;
        flex-direction: column;
        gap: 6px;
        margin-left: 0;
        margin-top: 12px;
        max-width: 100%;

        > li {
          padding: 0;
        }
      }

      & .ant-list-item-action-split {
        display: none;
      }
    `}
`;
